import axios from "./general/HttpClient";

export const GenerateFactionImage = (factionID, setMessage) => {
    let now = new Date();
    const _messages = [] as string[];
    setMessage("Starting generation...");
    return new Promise((resolve, reject) => {
        var eventSource = new EventSource("/api/factions/generateImage?id=" + factionID, { withCredentials: true });

        eventSource.onmessage = (event) => {
            console.log(event.data);

            if (event.data.indexOf("faction") == 0) {
                setMessage("Generating Faction Image");
            }

            if (event.data.indexOf("done") == 0) {
                setMessage("Finished in " + (new Date().getTime() - now.getTime()) / 1000 + "s");
                eventSource.close();
                resolve(true);
            }
        };
    });
};
